export default "__VITE_ASSET__veFc2CjH__"